export const MAX_CLASS_NAME_LENGTH = 12;
export const NOTIFICATION_TOAST_CLOSE_DELAY = 3000;
export const OPEN_OTHER_CLASS_LESSON_DELAY = 1000;
